import { Phone } from "lucide-react";

export default function EmergencyBar() {
  return (
    <a
      href="tel:9204152145"
      data-testid="emergency-hotbar-call-button"
      className="group fixed inset-x-0 bottom-0 z-[80] block border-t border-purple-500/30 bg-[#0B0714]/95 backdrop-blur-xl transition-colors duration-300 hover:bg-[#150A24]"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6 sm:py-3.5">
        <div className="flex items-center gap-3">
          <span className="animate-pulse-dot inline-block h-2.5 w-2.5 rounded-full bg-red-500" />
          <div className="leading-tight">
            <p className="font-mono-data text-[10px] uppercase tracking-[0.28em] text-purple-300 sm:text-xs">
              24/7 Emergency Line
            </p>
            <p className="font-mono-data text-sm font-semibold tracking-wider text-white sm:text-base">
              920-415-2145
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 rounded-full bg-purple-600 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white shadow-[0_0_24px_rgba(139,92,246,0.45)] transition-transform duration-300 group-hover:scale-105 sm:px-6 sm:text-sm">
          <Phone className="h-4 w-4" />
          <span className="hidden sm:inline">Tap to Call Now</span>
          <span className="sm:hidden">Call</span>
        </div>
      </div>
    </a>
  );
}
